import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import IosSvgColor from '../assets/ios.svg';

export const IosColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-ios" className={cx('sdkIcon', className)} size={size} {...props}>
    <IosSvgColor />
  </LegacyIcon>
);
